import React from "react";
import { ChartItem } from "../../types/chart";
import "./styles.scss";

interface Props {
  data: ChartItem[];
}

// The brand palette for a share bar, by rank (recharts and inline styles need literal colours):
// --brand blue, --spark orange, --ok green, --yellow; "Others" in --subtle grey.
const SEGMENT_COLORS = ["#2c42c3", "#ff5536", "#1f7a3d", "#f1c40f"];
const OTHERS_COLOR = "#8a8d94";

/** The colour of the segment at `index` (the biggest group first), "Others" always grey. */
export const segmentColor = (index: number, name?: string) =>
  name === "Others" ? OTHERS_COLOR : SEGMENT_COLORS[index % SEGMENT_COLORS.length];

// Segments are painted in the brand palette by position, so every caller's bar matches the brand.
const DemographicsBar: React.FC<Props> = ({ data }) => {
  return (
    <div className="demographics-container">
      <div className="demographics-bar">
        {data.map((item, index) => (
          <div
            key={index}
            className="bar-segment"
            data-tooltip={`${item.name}: ${item.value}`}
            style={{
              width: `${item.percent}%`,
              backgroundColor: segmentColor(index, item.name),
            }}
          />
        ))}
      </div>

      <div className="legend">
        {data.map((item, index) => (
          <div key={index} className="legend-item">
            <span className="legend-dot" style={{ backgroundColor: segmentColor(index, item.name) }} />
            <span className="legend-label">{item.name}</span>
            <span className="legend-percent">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DemographicsBar;
